import * as React from 'react'

import {
  Button,
  Divider,
  HStack,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  VStack,
} from '@chakra-ui/react'

import { BackButton, Page, PageBody, PageHeader } from '@saas-ui-pro/react'

import { useAuth } from '@saas-ui/auth'
import { Link } from '@saas-ui/react'
import { useCurrentUser } from '@app/features/core/hooks/use-current-user'

export interface OnboardingPageProps {
  isLoading?: boolean
  hideBackButton?: boolean
  children: React.ReactNode
}

export const OnboardingPage: React.FC<OnboardingPageProps> = (props) => {
  const { hideBackButton, children, ...pageProps } = props
  const { logOut } = useAuth()
  const { user, tenant, project } = useCurrentUser()

  const nav = (
    <HStack>
      {!hideBackButton && (
        <BackButton as={Link} href="/" title={'Back to the Dashboard'} />
      )}
      <Menu>
        <MenuButton
          as={Button}
          variant="ghost"
          textAlign="left"
          py="2"
          height="auto"
        >
          <HStack spacing={4}>
            <VStack align="flex-start" spacing={1}>
              <Text size="xs" color="muted">
                Logged in as
              </Text>
              <Text>{user?.primaryEmailAddress?.emailAddress}</Text>
            </VStack>

            {tenant?.name ? (
              <>
                <Divider orientation="vertical" height="24px" />
                <VStack align="flex-start" spacing={1}>
                  <Text size="xs" color="muted">
                    Organization:
                  </Text>
                  <Text>{tenant.name}</Text>
                </VStack>
              </>
            ) : null}

            {project ? (
              <>
                <Divider orientation="vertical" height="24px" />
                <VStack align="flex-start" spacing={1}>
                  <Text size="xs" color="muted">
                    Project:
                  </Text>
                  <Text>{project.name}</Text>
                </VStack>
              </>
            ) : null}
          </HStack>
        </MenuButton>
        <MenuList>
          <MenuItem onClick={() => logOut()}>Log out</MenuItem>
        </MenuList>
      </Menu>
    </HStack>
  )

  return (
    <Page {...pageProps}>
      <PageHeader nav={nav}></PageHeader>
      <PageBody maxW="full" position="relative">
        {children}
      </PageBody>
    </Page>
  )
}
